(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDeleteController',KiosksDeleteController);

    KiosksDeleteController.$inject = ['$uibModalInstance', 'entity', 'Kiosks'];

    function KiosksDeleteController($uibModalInstance, entity, Kiosks) {
        var vm = this;
        vm.kiosks = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Kiosks.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
